import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import NewColors from "../../../shared/theme/NewColors";
import { HEALTH_ACTIVITY_ACCENT } from "./SyncedHealthActivitiesSection";

/** Matches the calendar cell markers (tiny dots vs large icons — better fit on narrow days). */
function LegendDot({ color }) {
  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        bgcolor: color,
        boxShadow: (theme) => `0 0 0 1px ${alpha(theme.palette.common.black, 0.12)}`,
        flexShrink: 0,
      }}
    />
  );
}

const CalendarLegend = () => {
  return (
    <Box
      data-testid="calendar-legend"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        mt: 1,
        flexWrap: "wrap",
        rowGap: 0.65,
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.6,
          px: 1,
          py: 0.35,
          borderRadius: 1,
          backgroundColor: (theme) => `${theme.palette.primary.main}08`,
          border: (theme) => `1px solid ${theme.palette.primary.main}25`,
        }}
      >
        <LegendDot color="primary.main" />
        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ lineHeight: 1.2 }}>
          Mighty45 workout
        </Typography>
      </Box>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.6,
          px: 1,
          py: 0.35,
          borderRadius: 1,
          backgroundColor: `${NewColors.status.info}08`,
          border: `1px solid ${NewColors.status.info}30`,
        }}
      >
        <LegendDot color={NewColors.status.info} />
        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ lineHeight: 1.2 }}>
          Health &amp; macros
        </Typography>
      </Box>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.6,
          px: 1,
          py: 0.35,
          borderRadius: 1,
          backgroundColor: `${HEALTH_ACTIVITY_ACCENT}10`,
          border: `1px solid ${HEALTH_ACTIVITY_ACCENT}40`,
        }}
      >
        <LegendDot color={HEALTH_ACTIVITY_ACCENT} />
        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ lineHeight: 1.2 }}>
          Apple Health fitness
        </Typography>
      </Box>
    </Box>
  );
};

export default CalendarLegend;
